/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'
import TableX from 'DesignSystem/TableX/react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/Tasks/Content",
  value,
  onChange
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TableX
  viewPath={`${viewPath}/TableX`}
 enableRowSelection={true}
 value={value}
 onChange={onChange}
 fontSize={12}
 rightBorder={1}
 borderLeftWidthHeader={0}
 borderRightWidthHeader={1}
 borderRightStyleHeader="solid"
 borderRightColorHeader="#E4E7EB"
 borderBottomColor="#E4E7EB"
/>
</div>
{children}
</React.Fragment>)
}